import React from 'react';
import { Redirect } from 'react-router-dom';
import Menu from '../../../components/Menu';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';

export default function DashboardAtleta() {
    const usuario = JSON.parse(localStorage.getItem('userd7'));

    if (!usuario) {
        return <Redirect to="/" />;
    }

    if (usuario.perfil !== 'ATLETA_PROFISSIONAL') {
        return <Redirect to={usuario.perfil === 'ADMIN' || usuario.perfil === 'PRODUTOR' ? '/admin' : '/homeAtleta'} />;
    }

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <Header />
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1" style={{ marginTop: 20 }}>
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="mb-4">Bem vindo atleta {usuario.nome}</h4>
                                    <div className="mb-3">
                                        <label htmlFor="atleta-nome" className="form-label">Nome</label>
                                        <input id="atleta-nome" type="text" className="form-control" value={usuario.nome || ''} disabled />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="atleta-cpf" className="form-label">CPF</label>
                                        <input id="atleta-cpf" type="text" className="form-control" value={usuario.cpf || ''} disabled />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="atleta-email" className="form-label">Email</label>
                                        <input id="atleta-email" type="email" className="form-control" value={usuario.email || ''} disabled />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
            <div className="layout-overlay layout-menu-toggle" />
        </div>
    );
}
